import React from 'react';
import { Link } from 'react-router-dom';
export default function AutoLink(props) {
    const url = props.href || props.to;
    if (!url)
        return React.createElement("span", Object.assign({}, props));
    const is_link = ["http://", "https://", "//"].findIndex(test => url.indexOf(test) !== -1) !== -1;
    return is_link ? React.createElement("a", Object.assign({ href: url }, props, { to: undefined })) : React.createElement(Link, Object.assign({ to: url }, props, { href: undefined }));
}
